import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class Core extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get mainProductPage() {
    return get(this, '_main_product_page[0]', {});
  }

  get translations() {
    return get(this, '_translations[0]', {});
  }

  get newsletter() {
    return get(this, '_newsletter[0]', {});
  }

  get blogSEO() {
    return get(this, '_blog_seo[0].model', {});
  }

  get termsOfUseSEO() {
    return get(this, '_terms_of_use_seo[0].model', {});
  }

  get privacyPolicySEO() {
    return get(this, '_privacy_policy_seo[0].model', {});
  }

  get contactSEO() {
    return get(this, '_contact_seo[0].model', {});
  }

  get appRegulationsSEO() {
    return get(this, '_app_regulations_seo[0].model', {});
  }

  get footerProducts() {
    return get(this, '_footer___products', []);
  }

  get footerBlogArticleLink() {
    return get(this, '_footer___blog_article_link.value', '');
  }

  get blogContactComponent() {
    return get(this, '_blog_contact_component[0]', {});
  }

  get blogNewsletterThankYouPage() {
    return get(this, '_blog_newsletter_thank_you_page[0]', {});
  }
}



// WEBPACK FOOTER //
// ./src/models/Core.model.js